// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__w2k6R","wide":"Layout_wide__xFYJU"};